import React, { useMemo } from 'react';
import { KeyboardAvoidingView, Platform } from 'react-native';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import { WatchlistThesisForm } from '../../components/portfolio/WatchlistThesisForm';
import type { PortfolioNavigatorParamList } from '../../navigation/PortfolioNavigator';

type Nav = StackNavigationProp<PortfolioNavigatorParamList, 'AddWatchlistThesis'>;
type Route = RouteProp<PortfolioNavigatorParamList, 'AddWatchlistThesis'>;

export function WatchlistThesisScreen() {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const navigation = useNavigation<Nav>();
  const route = useRoute<Route>();
  const { watchlistItemId, symbol, instrumentName, currentPrice } = route.params;

  return (
    <KeyboardAvoidingView
      style={{ flex: 1, backgroundColor: theme.colors.background }}
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
    >
      <WatchlistThesisForm
        watchlistItemId={watchlistItemId}
        symbol={symbol}
        instrumentName={instrumentName}
        currentPrice={currentPrice}
        onCancel={() => navigation.goBack()}
        onSaved={() => navigation.goBack()}
      />
    </KeyboardAvoidingView>
  );
}
